import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            loggedInTenant: 'loggedInTenant'
        }),
        trafficLightSettings() {
            return this.loggedInTenant.tenantSettings.trafficLightRankingSettings;
        },
        redDescription() {
            return this.trafficLightSettings != null ? this.trafficLightSettings.redDescription : 'Under the standard';
        },
        amberDescription() {
            return this.trafficLightSettings != null ? this.trafficLightSettings.amberDescription : 'Inconsistently meeting the standard';
        },
        greenDescription() {
            return this.trafficLightSettings != null ? this.trafficLightSettings.greenDescription : 'Consistently meeting the standard';
        },
        naDescription() {
            return this.trafficLightSettings != null ? this.trafficLightSettings.naDescription : 'Not applicable or no opportunity to display in role';
        }
    }
}